<template>
    <div class="mt-4">
        <b-row>
            <b-col col lg="12" md="12" sm="12">
                <b-tabs>
                    <b-tab active>
                        <template slot="title">
                            <span class=""> Appointment Detail</span>
                        </template>
                        <appointment-tab :appointment="appointment"></appointment-tab>
                    </b-tab>
                    <b-tab>
                        <template slot="title">
                            <span class=""> Patient Info</span>
                        </template>
                        <patient-tab :patient="appointment.patient"></patient-tab>
                    </b-tab>

                    <b-tab>
                        <template slot="title">
                            <span class=""> Doctor Info</span>
                        </template>
                        <doctor-tab :doctor="appointment.doctor"></doctor-tab>
                    </b-tab>

                    <b-tab>
                        <template slot="title">
                            <span class=""> Vital</span>
                        </template>
                        <vital-tab :vital="appointment.vital || {}"></vital-tab>
                    </b-tab>

                    <b-tab>
                        <template slot="title">
                            <span class=""> Prescription</span>
                        </template>
                        <prescription-list :patient="appointment.patient"></prescription-list>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
    </div>
</template>

<script>
  import AppointmentTab from './Tabs/AppointmentTab';
  import PatientTab from './Tabs/PatientTab';
  import DoctorTab from './Tabs/DoctorTab';
  import VitalTab from './Tabs/VitalTab';
  import LabExamTab from './Tabs/LabExamTab';
  import PrescriptionList from '@/views/Prescription/PrescriptionList';

  export default {
    props: {
      appointment: {
        type: Object
      }
    },
    data() {
      return {}
    },

    components: {
      PrescriptionList,
      AppointmentTab,
      PatientTab,
      DoctorTab,
      VitalTab,
      LabExamTab
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Appointment/Detail/AppointmentDetailContent.vue